import { useMutation } from 'react-query';
import { useToast } from 'hooks/useToast';
import { useDashboard } from 'state/dashboard';

type TDeleteGroupParams = {
  groupId: string;
  onSuccessCallback?: () => void;
};

export const useDeleteGroup = () => {
  const { deleteGroup: executeDeleteGroupRequest } = useDashboard();
  const { renderCustomToast: toast } = useToast();

  const deleteGroup = useMutation({
    mutationFn: async ({ groupId, onSuccessCallback }: TDeleteGroupParams) => {
      const response = await executeDeleteGroupRequest(groupId);
      if (response?.status === 200 || response?.status === 204) {
        toast({
          title: 'Success',
          description: 'Saved search deleted successfully',
          status: 'success',
        });
        if (onSuccessCallback) {
          onSuccessCallback();
        }
      } else {
        toast({
          title: 'Error',
          description: 'Something went wrong - Failed to delete this saved search',
          status: 'error',
        });
      }
    },
    onError: () => {
      toast({
        title: 'Error',
        description: 'Something went wrong - Failed to delete this saved search',
        status: 'error',
      });
    },
  });

  return { deleteGroup };
};
